import { ReactComponent as IconClose } from "assets/svg/16-close.svg";
import { ReactComponent as IconWord } from "assets/svg/Word.svg";
import { ReactComponent as IconZip } from "assets/svg/Zip.svg";
import { ReactComponent as IconExcel } from "assets/svg/Excel.svg";
import { ReactComponent as IconDocument } from "assets/svg/Document.svg";
import { ReactComponent as IconPdf } from "assets/svg/Pdf.svg";

import {
  CloseButton,
  FileName,
  PreviewFile,
  PreviewFileWrapper,
  PreviewImage,
} from "./style";
import { isDoc, isExcel, isImage, isPdf, isZip } from "./const";
import ImagePreview from "./ImagePreview";
import { downloadFile } from "core/http/service/util";

interface Props {
  file: any;
  remove: () => void;
  error?: boolean;
  style?: any;
  isDownloadFile?: boolean;
}

const renderPreview = (fileName: string, fileContent: any) => {
  if (
    isImage(fileName) &&
    typeof fileContent === "string" &&
    fileContent.startsWith("data:image")
  ) {
    return <PreviewImage src={fileContent} alt={fileName} />;
  }
  if (typeof fileContent === "string" && isImage(fileName)) {
    return <ImagePreview url={fileContent} fileName={fileName} />;
  }

  if (isDoc(fileName))
    return (
      <PreviewFile>
        <IconWord />
      </PreviewFile>
    );
  if (isExcel(fileName))
    return (
      <PreviewFile>
        <IconExcel />
      </PreviewFile>
    );
  if (isZip(fileName))
    return (
      <PreviewFile>
        <IconZip />
      </PreviewFile>
    );
  if (isPdf(fileName))
    return (
      <PreviewFile>
        <IconPdf />
      </PreviewFile>
    );
  return (
    <PreviewFile>
      <IconDocument />
    </PreviewFile>
  );
};

const PreviewFiles = ({
  file,
  remove,
  error,
  style,
  isDownloadFile,
}: Props) => {
  const previewFile = () => {
    if (!file || !isDownloadFile) return;

    const fileName = file.originalFilename || "";
    let url = "";

    // Nếu có URL từ server
    if (file.path) {
      url = file.path;
    }

    if (!url) {
      alert("Không thể xem file này");
      return;
    }

    // Đối với hình ảnh và PDF - mở trong tab mới
    if (isPdf(fileName)) {
      window.open(url, "_blank")?.focus();
    } else if (!isImage(fileName)) {
      downloadFile(url, fileName);
    }
  };

  return (
    <PreviewFileWrapper
      title={file?.name}
      error={error}
      style={{ ...style, cursor: isDownloadFile ? "pointer" : "default" }}
      onClick={previewFile}
    >
      {renderPreview(
        file?.name || file?.originalFilename,
        file?.content || file?.path
      )}
      <FileName>{file?.name || file?.originalFilename}</FileName>
      {!isDownloadFile && (
        <CloseButton className="close" onClick={remove}>
          <IconClose />
        </CloseButton>
      )}
    </PreviewFileWrapper>
  );
};

export default PreviewFiles;
